var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { fullscreen: "", scrollable: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "px-4",
                      attrs: { color: "primary", depressed: "", outlined: "" },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(" ดูตัวอย่าง ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "barcode-preview", attrs: { color: "#F0F2F5" } },
        [
          _c("v-card-title"),
          _c("v-card-text", { staticClass: "d-flex flex-column" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-center align-center gap-6 mb-6" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary", icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(_vm.page - 1)
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                  1
                ),
                _c("div", [
                  _vm._v(_vm._s(_vm.page) + " of " + _vm._s(_vm.items.length)),
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary", icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(_vm.page + 1)
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                ref: "barcodePreview",
                staticClass:
                  "barcode-preview__container modern-scrollbar overflow-auto h-100",
              },
              [
                _c(
                  "div",
                  { staticClass: "mx-auto" },
                  [
                    _vm._l(_vm.items.length, function (p) {
                      return [
                        _c("BarcodePaper", {
                          key: `barcode-${p}`,
                          ref: `barcode-${p}`,
                          refInFor: true,
                          staticClass: "barcode-preview__paper",
                          attrs: {
                            id: `barcode-${p}`,
                            items: [_vm.items[p - 1]],
                            elements: _vm.elements,
                            width: _vm.width,
                            height: _vm.height,
                            col: _vm.col,
                            row: _vm.row,
                            my: _vm.my,
                            mx: _vm.mx,
                            omy: _vm.omy,
                            omx: _vm.omx,
                            imy: _vm.imy,
                            "font-size": _vm.fontSize,
                            "show-barcode-number": _vm.showBarcodeNumber,
                          },
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "pr-4",
                  attrs: { color: "primary", depressed: "", rounded: "" },
                  on: {
                    click: function ($event) {
                      return _vm.download()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(" mdi-download "),
                  ]),
                  _vm._v(" Download "),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-6",
                  attrs: { color: "primary", rounded: "", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.setDialog(false)
                    },
                  },
                },
                [_vm._v(" ยกเลิก ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", depressed: "", rounded: "" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(" พิมพ์ ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }